import React, { useEffect, useState, Suspense, lazy } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { SG_GET_ORG_GROUPS, ORG_GROUPS_PAGE } from "constants/actions";
import {
  List,
  Header,
  Loader,
  Message,
  Pagination,
  Segment,
  Button,
  Dropdown,
} from "semantic-ui-react";
import { Link } from "react-router-dom";

const ListOrganizations = () => {
  const dispatch = useDispatch();

  const { orgGroupsPage, loading, error, organizationSelect } = useSelector(
    (state) => ({
      orgGroupsPage: state.groups.orgGroupsPage,
      loading: state.groups.loading,
      error: state.groups.error,
      organizationSelect: state.organizations.organization_select,
    }),
    shallowEqual
  );
  const [selectedOrgId, setSelectedOrgId] = useState(null);
  const [appliedOrgId, setAppliedOrgId] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const pageSize = 12;

  // Fetch organizations dropdown on mount
  useEffect(() => {
    dispatch({ type: "SG_GET_ORGANIZATION_SELECT" });
  }, [dispatch]);

  // Fetch org groups on mount and when page or appliedOrgId changes
  useEffect(() => {
    const payload = { page, page_size: pageSize };
    if (appliedOrgId) {
      payload.organization = appliedOrgId;
    }
    dispatch({
      type: SG_GET_ORG_GROUPS,
      payload,
    });
  }, [dispatch, page, appliedOrgId]);

  // Update total pages when orgGroupsPage changes
  useEffect(() => {
    if (orgGroupsPage && orgGroupsPage.count && orgGroupsPage.page_size) {
      setTotalPages(Math.ceil(orgGroupsPage.count / orgGroupsPage.page_size));
    }
  }, [orgGroupsPage]);

  const handlePageChange = (event, { activePage }) => {
    setPage(activePage);
    dispatch({
      type: ORG_GROUPS_PAGE,
      payload: { pageNumber: activePage, organization: appliedOrgId },
    });
  };

  // Apply filter button click
  const handleApplyFilter = () => {
    console.log("Applying filter for Organization ID:", selectedOrgId);
    setAppliedOrgId(selectedOrgId);
    setPage(1); // Reset to first page
  };

  // Clear filter button click
  const handleClearFilter = () => {
    console.log("Clearing filter");
    setSelectedOrgId(null);
    setAppliedOrgId(null);
    setPage(1);
  };

  if (loading) return <Loader active>Loading organizations...</Loader>;
  if (error) return <Message negative>{error}</Message>;

  // Format organizations for dropdown
  const orgOptions = (organizationSelect || []).map((org) => ({
    key: org.id,
    text: `${org.id} # ${org.name}`,
    value: org.id,
  }));

  return (
    <div style={{ padding: 30 }}>
      {/* Filter Section */}
      <Segment>
        <Header as="h4">Filter by Organization</Header>
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <Dropdown
            placeholder="Select Organization"
            fluid
            search
            selection
            options={orgOptions}
            value={selectedOrgId}
            onChange={(e, { value }) => setSelectedOrgId(value)}
            style={{ flex: 1, maxWidth: "400px" }}
          />
          <Button primary onClick={handleApplyFilter} disabled={!selectedOrgId}>
            Apply Filter
          </Button>
          <Button secondary onClick={handleClearFilter} disabled={!appliedOrgId}>
            Clear Filter
          </Button>
        </div>
        {appliedOrgId && (
          <Message info style={{ marginTop: "10px" }}>
            <strong>Active Filter:</strong> Organization ID {appliedOrgId}
          </Message>
        )}
      </Segment>

      <Segment basic>
        <Pagination
          activePage={page}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
        <List divided relaxed>
          {orgGroupsPage &&
          orgGroupsPage.results &&
          orgGroupsPage.results.length > 0 ? (
            orgGroupsPage.results.map((org) => (
              <List.Item key={org.id}>
                <List.Icon
                  name="building"
                  size="large"
                  verticalAlign="middle"
                />
                <List.Content>
                  <List.Header
                    as={Link}
                    to={`organization/${org.id}/employees`}
                    style={{ cursor: "pointer" }}
                  >
                    {org.id} # {org.name}
                  </List.Header>
                  <List.Description>{org.description}</List.Description>
                </List.Content>
              </List.Item>
            ))
          ) : (
            <List.Item>No organizations found.</List.Item>
          )}
        </List>
        <Pagination
          activePage={page}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </Segment>
    </div>
  );
};

export default ListOrganizations;
